import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchUsers } from "../../../actions/mods_factory/usersActions";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import List from "./_partials/_List";
import PageHeader from "../../../componets/PageHeader";
import Block from "./Block";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import './style.scss';

const LIMIT = 42;

const Users = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        show_addons: true
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchUsers(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-users'>
      <PageHeader title='Users' />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              items: [
                { name: 'Register', key: 'id' },
                { name: 'Seen', key: 'current_sign_in_at' },
                { name: 'Popular', key: 'popular_count' },
                // { name: 'Activity', key: 'activity' },
                // { name: 'Post',     key: 'post' }
              ]
            }}
          />
        </Wrapper>

        <List limit={LIMIT} />
      </div>

      <Edit />
      <Block />
    </PageLayout>
  );
}

export default Users;
